import dayjs, { type Dayjs } from 'dayjs';
import type { CropMonitoring } from '/@/types/crop-monitoring';

export const isActiveCorn = (cropMonitoring?: CropMonitoring): boolean =>
    Boolean(cropMonitoring?.active) && cropMonitoring?.crop === 'corn';

/** Active corn at physiological maturity (`phenology === 'maturity'`). */
export const isCornMaturity = (
    cropMonitoring?: CropMonitoring,
    { withoutHarvest = false }: { withoutHarvest?: boolean } = {}
): boolean =>
    isActiveCorn(cropMonitoring) &&
    cropMonitoring?.cornCropMonitoring?.phenology === 'maturity' &&
    (!withoutHarvest || !cropMonitoring?.harvestDate);

/** Expected harvest date from the CM payload, falling back to maturity + 60 days. */
export const resolveExpectedHarvestDate = (corn: CropMonitoring['cornCropMonitoring']): Dayjs | null => {
    if (!corn) return null;

    const fromHarvest = corn.expectedHarvestDate ? dayjs(corn.expectedHarvestDate) : null;
    if (fromHarvest?.isValid()) return fromHarvest;

    const maturity = corn.expectedMaturityDate ? dayjs(corn.expectedMaturityDate) : null;
    return maturity?.isValid() ? maturity.add(60, 'day') : null;
};
